module.exports = __webpack_public_path__ + "img/mobile-btn-spare.df69626f.webp";